import React from 'react';
import {isFreeVersion} from './helpers';

module.exports = React.createClass({

    getInitialState: function () {
        return {
            showSignUp: false,
        }
    },

    componentWillMount: function() {
        HC_CloseModal();
        if (!window.HC_LastError) {
            this.render = function() { return (<div/>);};
            HC_GoMainPage();
        }
    },

    componentDidMount: function() {
        if (window.HC_LastError && window.HC_LastError.code == 401)
            HC_GoMainPage();
    },

    handleBackToHome: function(){
        HC_GoMainPage();
    },

    render: function() {
        if ($("#nav-panel").css("display") !=  "none")
            HC_ToggleNavPanel();

        var error = window.HC_LastError;
        var errorCaption = "An error has occurred";
        switch (error.code) {
            case 400: errorCaption = 'Error 400 - Bad Request'; break;
            case 401:
                //errorCaption = 'Error 401 - Unauthorized';
                return (<div></div>);
                break;
            case 403: errorCaption = 'Error 403 - Permission Denied'; break;
            case 404: errorCaption = 'Error 404 - Not Found'; break;
            case 409: errorCaption = 'Error 409 - Conflict'; break;
            case 500: errorCaption = 'Error 500 - Internal Server Error'; break;
        }

        var errorText = error.message;

        return (
            <div style={{ width:"100%", height:"100%", textAlign:"center"}}>

                <div align="center" style={{padding:"5%"}} >
                    <img src={window.HC_SITE_LOGO.src} style={window.HC_SITE_LOGO.style} alt="logo" />
                </div>

                <div style={{bottom: "0", left: "0", top: "0", right: "0", margin: "auto", position: "absolute", maxWidth: "100%", height: "20%"}}>
                    <p className="hc-f2">{errorCaption}</p>
                    <p className="hc-f3">{errorText}</p>
                    <p className="hc-f4 hc-link" onClick={this.handleBackToHome} style={{ textDecoration: "underline", cursor:"pointer" }}>Back to home page</p>
                </div>
            </div>
        );
    }
});


// WEBPACK FOOTER //
// ./error.js